import { useQuery } from 'react-query';
import { getPaymentList, type GetPaymentListResponse } from '../../services/paymentService';

export function useGetPaymentList() {
  return useQuery<GetPaymentListResponse, Error>(['bettiePayments'], getPaymentList, {
    staleTime: 60 * 1000,
    cacheTime: 5 * 60 * 1000
  });
}
